export default __webpack_public_path__ + "static/media/total-cars.d53f89e6.svg";